import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=a5f7ef00&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=a5f7ef00&prod&lang=css"
import style1 from "./settings.vue?vue&type=style&index=1&id=a5f7ef00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f7ef00",
  null
  
)

export default component.exports